import fetchInit from '../lib/fetchInit';

export const receive_kwargs = async () => {
  const response = await fetch(window.location.href, fetchInit(JSON.stringify({type: 'get_kwargs'})));
  return await response.json();
};

export const receive_context = async (database) => {
  if (database == null) {
    const response = await fetch('./serve_context', fetchInit());
    return await response.json();
  } else {
    const data = {database};
    const response = await fetch('../serve_context', fetchInit(JSON.stringify(data)));
    return await response.json();
  }
};

export const receive_database = async (database) => {
  const data = {database};
  const response = await fetch('../serve_database', fetchInit(JSON.stringify(data)));
  return await response.json();
};

export const receive_databases = async (database) => {
  const url = database == null ? './serve_databases' : '../serve_databases';
  const response = await fetch(url, fetchInit());
  return await response.json();
};

export const receive_vars = async ({database, model, ensemble, experiment, frequency, all}) => {
  const data = {database, model, ensemble, experiment, frequency, all};
  const response = await fetch('../serve_vars', fetchInit(JSON.stringify(data)));
  return await response.json();
};

export const receive_past = async ({database, model, ensemble, experiment, frequency, variables}) => {
  const data = {database, model, ensemble, experiment, frequency, variables};
  const response = await fetch('../serve_past', fetchInit(JSON.stringify(data)));
  return await response.json();
};

export const receive_spatial_settings = async (database) => {
  const data = {database};
  const response = await fetch('../serve_spatial_settings', fetchInit(JSON.stringify(data)));
  return await response.json();
};

export const receive_masks = async (database) => {
  const data = {database};
  const response = await fetch('../serve_masks', fetchInit(JSON.stringify(data)));
  return await response.json();
};

export const request_downloadfile_generation = async (postData) => {
  // console.log(postData);
  const response = await fetch('../serve_downloadfile_generation', fetchInit(JSON.stringify(postData)));
  return await response.json();
};

export const request_imgfile1d_generation = async (postData) => {
  const response = await fetch('../serve_imgfile1d_generation', fetchInit(JSON.stringify(postData)));
  if (!await response.ok) {
    // console.log(response);
    return null;
  }
  return await response.blob();
};

export const request_imgfile2d_generation = async (postData) => {
  const response = await fetch('../serve_imgfile2d_generation', fetchInit(JSON.stringify(postData)));
  if (!await response.ok) {
    // console.log(response);
    return null;
  }
  return await response.blob();
};

export const request_statistics_generation = async (postData) => {
  const response = await fetch('../serve_statistics_generation', fetchInit(JSON.stringify(postData)));
  if (!await response.ok) {
    // console.log(response);
    return null;
  }
  return await response.json();
};

export const receive_csv = async ({token, file}) => {
  const data = {token, file};
  const response = await fetch('./serve_csv', fetchInit(JSON.stringify(data)));
  if (!await response.ok) {
    return {success: false};
  }
  return await response.json();
};

export const receive_download_list = async () => {
  const response = await fetch('./serve_download_list', fetchInit());
  return await response.json();
};

export const receive_download_file_list = async (ids) => {
  const data = {ids};
  const response = await fetch('./serve_download_file_list', fetchInit(JSON.stringify(data)));
  if (!await response.ok) {
    return {success: false};
  }
  return await response.json();
};

export const receive_log = async (id) => {
  const data = {id};
  const response = await fetch('./serve_log', fetchInit(JSON.stringify(data)));
  if (!await response.ok) {
    return {success: false};
  }
  return await response.json();
};

export const receive_numeric1d = async (postData) => {
  const response = await fetch('../serve_numeric1d', fetchInit(JSON.stringify(postData)));
  if (!await response.ok) {
    return {success: false};
  }
  return await response.json();
};

export const request_trash_download = async (ids) => {
  const data = {ids};
  const response = await fetch('./serve_trash_download', fetchInit(JSON.stringify(data)));
  if (!await response.ok) {
    return {success: false};
  }
  return await response.json();
};
